import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const DRPROXSERVICES_URL = generateUrl()

const drpServicesServiceApiInstance = axios.create({
    baseURL: `${DRPROXSERVICES_URL}/drproxservices`
})

drpServicesServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
drpServicesServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default drpServicesServiceApiInstance
